import IMask from './imask';
import './jquery-validation';
import emailautocomplete from './email-autocomplete';
import './jquery-ui';


let language = $('html').attr('lang');

// Convert first letter of each word to uppercase and others to lowercase
let capitalize = function (e) {
    let thisVal = this.value.toLowerCase().replace(/(^|\s|\-)\S/g, function (match) {
        return match.toUpperCase();
    });
    // Store current positions in variables.
    var selectionStart = this.selectionStart;
    var selectionEnd = this.selectionEnd;

    this.value = ((e.data != undefined && e.data.search != undefined) ? thisVal.replace(e.data.search, e.data.replace) : thisVal);

    // Restore from variables.
    this.setSelectionRange(selectionStart, selectionEnd);
}

// Convert to uppercase
let transformUpperCase = function (e) {
    this.value = this.value.toUpperCase();
};

// Force mask to pre-fill if user types any char in mask, e.g. "4" or "8"
let telPrefill = function (e) {
    if (this.value == '' && e.keyCode != 48) {
        this.value = ' ';
    }
};

let autoCompleteMinLength = (language == 'ro') ? 3 : 1;

$(function () {

    switch (language) {
        case 'pl':
            $('.js-name-mask').on('keyup mouseup', { search: /\-/g, replace: ' ' }, capitalize);
            $('.js-surname-mask').on('keyup mouseup', { search: /\s/g, replace: '-' }, capitalize);
            break;
        case 'ro':
            $('.js-name-mask').on('keyup mouseup', capitalize);
            $('.js-surname-mask').on('keyup mouseup', capitalize);
            break;
        default:
        // code block
    }

    $('.city, .home-city').on('keyup mouseup', capitalize);
    $('.street, .home-street').on('keyup mouseup', capitalize);
    $('.tel-require,.confirm-tel').on('keydown', telPrefill);

    $('.js-idno-mask').on('keyup mouseup', transformUpperCase);

    $('input.confirm-email, input.confirm-tel').on("cut copy paste", function (e) {
        e.preventDefault();
    });

    $('.input-field-wrap').addClass('noBorder');

    //Revalidate Select2 control when user selects value
    $('body').on("select2:close", 'select', function () { $(this).focus(); });

    //Fire validation on tab out
    $('body').on('blur', '.select2-selection', function () { $(this).closest('.input-field-wrap').find('select').valid(); });

    //Revalidate Yes/No Radio buttons when user selects value
    $('body').on('click', '.checkbox-choosed a', function () {
        $(this).closest('.checkbox-choosed-wrap').find('input[type="radio"]').valid();
    });
});

export default class FormValidationSimple {
    constructor() {
        this.dom = {
            $: window.$,
            jQuery: window.$,
            $form: $('form'),
            $allInputs: $(":input"),
            $mail: $('.email'),
            $checkboxChoosed: $('.checkbox-choosed-wrap'),
            $marketingChecks: $('.form-agree-rest'),
            $toggleDisabledInput: $('.toggle-disabled-input'),
            maskArray: [, , ,]
        };
        this.domains = [
            'wp.pl', 'onet.pl', 'o2.pl', 'op.pl', 'tlen.pl', 'poczta.fm', 'gazeta.pl',
            'vp.pl', 'go2.pl', 'interia.pl', 'poczta.onet.pl'
        ];
        if (this.dom.$form) {
            this.init();
        }
    }

    init() {
        let that = this;
        $.extend($.validator.messages, this.dom.customMessages);
        let $selectors = this.dom.$allInputs;
        that.applyValidationRules();
        $selectors.filter("[data-val=true]").each(function (index, element) {
            that.applyMask(index, $(element));

            //Destroy iMask object and reapply iMask if field changed
            if ($(element).data("val-mask") && $(element).data("val-mask-regex")) {
                $(element).on('change', () => {
                    that.applyMask(index, $(this));
                });
            }
            /*that.appendMailAutocomplete($(element));*/
            that.applyValidation($(element));
        });
        that.toggleInputDisabled();
        that.initToggleInputFocus();
        that.applyFormValidate();
        $selectors.filter("[data-autocomplete=true]").each(function (index, element) {
            that.applyAutocomplete($(element));
        });
        that.checkboxChoosed();
    }

    initToggleInputFocus() {
        let $selectors = this.dom.$form.find('input, textarea').not('[type=checkbox]');

        $selectors
            .on('focus blur', this.toggleInputFocus.bind(this))
            .each((_, element) => {
                this.toggleInputFocus(element);
            });
    }

    toggleInputFocus(e) {
        if (!e) return;
        let $input = $(e.currentTarget ? e.currentTarget : e);
        let $parent = $input.parent();
        let $desiredElem = $parent.hasClass('eac-input-wrap') ? $parent.parent() : $parent;

        /** Trigger validation on autocomplete **/
        if (e.type === 'blur' && $input.prop('type') === 'email') {
            setTimeout(() => $input.trigger('focusout.validate', 200));
        }
        if ($parent.parent().hasClass('disabled')) {
            return;
        }

        $desiredElem
            .toggleClass('filled', $input.val().length > 0)
            .toggleClass('focus', document.activeElement === $input[0]);

        setTimeout(() => {
            $desiredElem.next('.input-results')
                .toggleClass('hidden', document.activeElement !== $input[0]);
        }, 200);
    }

    checkboxChoosed() {
        if (!this.dom.$checkboxChoosed.length) {
            return;
        }

        this.dom.$checkboxChoosed
            .find('.checkbox-choosed a')
            .on('click', (e) => {
                e.preventDefault();
                let $a = $(e.currentTarget);

                $a.addClass('active').siblings().removeClass('active');
                $a.closest('.checkbox-choosed-wrap').find("input").removeAttr('checked');
                $a.closest('.checkbox-choosed-wrap').find(`input[value=${$a.data('check')}]`).attr('checked', 'true');
            });
    }

    applyMask(id, element) {
        let thisDom = this.dom;
        if (element.data("val-mask") && element.data("val-mask-regex")) {
            var reg;
            try {
                switch (element.data("val-mask-regex-type")) {
                    case "String":
                    case "Number":
                    case "Date":
                        reg = element.data("val-mask-regex");
                        break;
                    case "RegularExp":
                    default:
                        reg = new RegExp(element.data("val-mask-regex"));
                        break;
                }
            }
            catch (err) {
                reg = element.data("val-mask-regex");
            }

            var opts = $.extend({ mask: reg }, element.data("val-mask-regex-obj"));

            if (thisDom.maskArray[id] != undefined) {
                thisDom.maskArray[id].destroy();
            }
            thisDom.maskArray[id] = IMask(element[0], opts);
        }
    }

    //appendMailAutocomplete(element) {
    //    if (this.dom.$mail.length !== 0 && element.hasClass("email")) {
    //        emailautocomplete(this.dom.$mail[0], {
    //            domains: this.domains,
    //            suggClass: 'eac-suggestion'
    //        });
    //    }
    //}

    applyValidationRules() {
        let that = this;

        $.validator.addMethod('compare', function (value, ele) {
            return $(ele).val().toLowerCase() === $(`input[data-validator-id=${$(ele).data("val-compare-to")}]`).val().toLowerCase();
        }, function (params, elem) {
            return $(elem).data("val-compare-message");
        });

        $.validator.addMethod('ajaxvalidation', function (value, ele) {
            var isValid = false;
            $(ele).closest('.input-field-wrap').find('.input-field-sufix').hide();
            $(ele).closest('.input-field-wrap').find('.input-field-spinner').show();
            $(ele).data("errMessage", "");
            $.ajax({
                type: 'POST',
                async: false,
                url: $(ele).data("val-ajax-url"),
                data: { input: value },
                error: function () {
                    //$(ele).closest('.input-field-wrap').find('.input-field-spinner').hide();
                },
                success: function (response) {
                    if ($(ele).data("val-ajax-callback")) {
                        //Use field specific callback function in sitecore
                        isValid = window[$(ele).data("val-ajax-callback")](response, ele);
                    } else {
                        $(ele).data("errMessage", response.ErrDescription);
                        isValid = response.IsValid;
                    }
                    //$(ele).closest('.input-field-wrap').find('.input-field-spinner').hide();
                }
            });
            setTimeout(function () {
                $(ele).closest('.input-field-wrap').find('.input-field-spinner').hide();
                $(ele).closest('.input-field-wrap').find('.input-field-sufix').show();
            }, 100);
            return isValid;
        }, function (params, elem) {
            //$(elem).closest('.input-field-wrap').find('.input-field-spinner').hide();
            return $(elem).data("errMessage");
        });

        $.validator.addMethod('regex', function (value, ele) {
            var reg;
            try {
                reg = new RegExp($(ele).data("val-regex-pattern"));
            }
            catch (err) {
                reg = $(ele).data("val-regex-pattern");
            }
            return reg.test(value) || (value.replace(' ', '') == '' && $(ele).data("val-required") != true);
        }, function (params, elem) {
            return $(elem).data("val-regex-message");
        });


        $.validator.addMethod('minlength', function (value, element, param) {
            var length = $.isArray(value) ? value.length : this.getLength(value, element);
            return this.optional(element) || length >= param;
        }, function (params, elem) {
            return $(elem).data("val-min-max-message");
        });

        $.validator.addMethod('maxlength', function (value, element, param) {
            var length = $.isArray(value) ? value.length : this.getLength(value, element);
            return this.optional(element) || length <= param;
        }, function (params, elem) {
            return $(elem).data("val-min-max-message");
        });

        $.validator.addMethod('requiredvalidation', function (value, ele) {
            var type = $(ele).attr("type");
            switch (type) {
                case "radio": {
                    return $("input[name='" + $(ele).attr("name") + "'").is(":checked");
                }
                case "checkbox": {
                    return $(ele).is(":checked");
                }
                default: {
                    return value != undefined && $(ele).val().length > 0 && !($(ele).hasClass("number") && (parseFloat('0' + value.replace(' ', '')) <= 0));
                }
            }
        }, function (params, elem) {
            return $(elem).data("val-required-message");
        });

    }

    applyValidation(element) {
        let that = this;
        $.validator.addClassRules(element.data("validator-id"),
            {
                requiredvalidation: element.data("val-required"),
                compare: element.data("val-compare"),
                regex: element.data("val-regex"),
                ajaxvalidation: element.data("val-ajax")

            }
        );
    }

    applyAutocomplete(element) {
        let that = this;
        let thisDom = this.dom;
        element.autocomplete({
            source: function (request, response) {
                element.closest('.input-field-wrap').find('.input-field-spinner').show();

                var postJson = element.data("autocomplete-json");
                var autocompleteUrl = element.data("autocomplete-url");
                var postData = that.setJsonProperties(postJson);

                function successCallback(data) {
                    cLog(data);
                    var parsed = JSON.parse(data);
                    var newArray = new Array(parsed.length);
                    var i = 0;
                    parsed.forEach(function (entry) {
                        var newObject = {
                            label: entry
                        };
                        newArray[i] = newObject;
                        i++;
                    });
                    response(newArray);
                    element.closest('.input-field-wrap').find('.input-field-spinner').hide();
                }

                function failureCallback(xhr, textStatus) {
                    cLog(textStatus);
                    response([]);
                }

                getAjaxData(autocompleteUrl, "POST", true, postData, successCallback, failureCallback);
            },
            minLength: autoCompleteMinLength,
            change: function (event, ui) {
                if (language == 'ro') {
                    let $thisField = $(this);
                    if ($thisField.hasClass('county') || $thisField.hasClass('city') || $thisField.hasClass('home-county') || $thisField.hasClass('home-city')) {
                        $thisField.val((ui.item ? ui.item.label : "").toLowerCase().replace(/(^|\s|\-)\S/g, function (match) {
                            return match.toUpperCase();
                        }));
                    }
                    if ($thisField.hasClass('county')) {
                        resetFields($('.ro-name:not(.county), .ro-number'));
                    }

                    if ($thisField.hasClass('city')) {
                        resetFields($('.ro-name:not(.city, .county), .ro-number'));
                    }

                    if ($thisField.hasClass('street')) {
                        resetFields($('.ro-name:not(.street, .county, .city), .ro-number'));
                    }

                    if ($thisField.hasClass('home-county')) {
                        resetFields($('.ro-home-name:not(.home-county), .ro-home-number'));
                    }

                    if ($thisField.hasClass('home-city')) {
                        resetFields($('.ro-home-name:not(.home-city, .home-county), .ro-home-number'));
                    }

                    if ($thisField.hasClass('home-street')) {
                        resetFields($('.ro-home-name:not(.home-street, .home-county, .home-city), .ro-home-number'));
                    }

                    function resetFields($fields) {
                        $fields.each((id, thisField) => {
                            $(thisField).val('');
                            if ($fields.index($(thisField)) > ($thisField.hasClass('form-error') ? 0 : 1)) $(thisField).prop('disabled', true);
                            let thisId = thisDom.$allInputs.filter("[data-val=true]").index($(thisField));
                            that.applyMask(thisId, $(thisField));
                        });
                    }
                }
            }
        });
    }

    setJsonProperties(json) {
        var finalJson = {};
        $.each(json, function (index, value) {
            var propRegex = /#(.*)#/g;
            if (typeof value === "object") {
                setJsonProperties(value);
            } else {
                var match = propRegex.exec(value);
                if (match) {
                    finalJson[index] = $(`[data-validator-id="${match[1]}"]`).val().trim();
                } else {
                    finalJson[index] = value;
                }
            }
        });

        return finalJson;
    }

    applyFormValidate() {
        let $forms = $('form');
        var that = this;

        $forms.each(function () { // attach to all form elements on page
            $(this).validate({ // initialize plugin on each form
                ignore: ":not(:visible, .form-agree-list .accordion-content :hidden), :disabled",
                onkeyup: false,
                rules: {},
                messages: {},
                errorElement: 'span',
                errorClass: 'form-error',
                errorPlacement: (error, elem) => {
                    $("#" + error.attr("id")).remove();
                    elem.closest('.form-input-group').append(error);
                },
                submitHandler: (form) => {
                    $(form).find('.form-error-global').addClass('hidden');
                    if (!$(form).hasClass('open-popup')) {
                        // Prevent double submit
                        if ($(form).data('submitted') === true) {
                            // Previously submitted - don't submit again
                            return false;
                        } else {
                            //success so show processing icon
                            $('.loading-sceen').show();
                            that.saveCalculatorData();
                            //Mark form as 'submitted' so that the next submit can be ignored
                            $(form).data('submitted', true);
                            return true;
                        }
                    }
                },
                invalidHandler: (elem) => {
                    $(elem.currentTarget).find('.form-err-info').attr('style', 'display:none;');
                    that.showHiddenAccErrors();
                    $(elem.currentTarget).find('.form-error-global').removeClass('hidden');
                },
                onfocusout: function (element) {
                    if (element.type == "text") {
                        element.value = element.value.replace(/^[-|\s]*(.*?)[-|\s]*$/, function (a, b) { return b; });
                    }
                    return this.element(element);
                }
            });
        });
    }

    saveCalculatorData() {
        if ($('.js-calc-submit').length > 0) {
            $('.js-calc-submit').trigger('click');
        }
    }

    //If form error then open all accordians
    showHiddenAccErrors() {
        if (this.dom.$marketingChecks.length === 0) return false;

        let acordObj = '';
        $.each($('.form .accordion-trigger'), function (key, value) {
            if (!$(value).hasClass('accordion-open') && !$(value).hasClass('diff-address')) {
                acordObj = $(value).data('target');
                $(value).toggleClass('accordion-open');
                $(acordObj).slideDown();
            }
        });
    }

    toggleInputDisabled() {
        if (!this.dom.$toggleDisabledInput.length) {
            return;
        }

        this.dom.$toggleDisabledInput.on('change', (e) => {
            let $input = $(e.currentTarget);
            let $target = $($input.attr('data-target'));

            if ($input.is(':checked')) {
                $target.addClass('disabled');
                $target.find('input').prop('disabled', true);
            } else {
                $target.removeClass('disabled');
                $target.find('input').prop('disabled', false);
            }
        }).trigger('change');
    }
}